export default [
  {
    header: 'แจ้งเบาะแส',
    menu: 'Clue'
  },
  {
    title: "เพิ่มเรื่อง",
    route: "ClueManage",
    icon: "CircleIcon",
    menu: 'ClueManage',
  },
  {
    title: "ค้นหา",
    route: "ClueSearch",
    icon: "CircleIcon",
    menu: 'ClueSearch',
  },
  // {
  //   title: "ตรวจสอบ",
  //   route: "ClueCheck",
  //   icon: "CircleIcon",
  //   menu: 'ClueCheck',
  // },
  {
    title: "ดำเนินการ",
    route: "ClueAction",
    icon: "CircleIcon",
    menu: 'ClueAction',
  },
  {
    title: "แนบเอกสารเพิ่มเติม",
    route: "ClueAttachment",
    icon: "CircleIcon",
    menu: "ClueAttachment",
  },
]
